var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendTestiInvitation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6185_30583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05724 9.03557C6.07307 9.07502 6.10059 9.10869 6.1361 9.13205C6.17162 9.15541 6.21343 9.16734 6.25592 9.16626C6.29841 9.16517 6.33956 9.15111 6.37383 9.12596C6.4081 9.10081 6.43386 9.06578 6.44765 9.02557L9.15599 1.10891C9.16932 1.07199 9.17187 1.03203 9.16332 0.99372C9.15478 0.955407 9.1355 0.920319 9.10775 0.892563C9.07999 0.864806 9.0449 0.845528 9.00659 0.836985C8.96828 0.828442 8.92832 0.830987 8.8914 0.844322L0.974737 3.55266C0.934527 3.56644 0.899497 3.5922 0.87435 3.62648C0.849203 3.66075 0.835141 3.70189 0.834053 3.74439C0.832964 3.78688 0.844901 3.82869 0.868261 3.86421C0.891621 3.89972 0.925285 3.92724 0.964736 3.94307L4.2689 5.26807C4.37336 5.30989 4.46826 5.37243 4.54789 5.45192C4.62752 5.5314 4.69023 5.62619 4.73224 5.73057L6.05724 9.03557Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10521 0.894531L4.54688 5.45245",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6185_30583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendTestiInvitation);
export default __webpack_public_path__ + "static/media/sendTestiInvitation.1aa320819648bb5d37468790979361df.svg";
export { ForwardRef as ReactComponent };